import * as React from "react";
import { DetailsToast } from "common/context/toast/details-toast";

const ToastDispatchContext = React.createContext(undefined);
ToastDispatchContext.displayName = "ToastDispatchContext";

const initialState = {
  isOpen: false,
  type: "normal",
  message: "",
  isExpanded: false,
  details: "",
};

const actionTypes = {
  toastClosed: "TOAST_CLOSED",
  successfulAction: "SUCCESSFUL_ACTION",
  errorHappened: "ERROR_HAPPENED",
  warningHappened: "WARNING_HAPPENED",
  toggleToastDetails: "TOGGLE_TOAST_DETAILS",
};

function toastReducer(state, action) {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.toastClosed:
      return initialState;
    case actionTypes.toggleToastDetails:
      return {
        ...state,
        isExpanded: !state.isExpanded,
      };
    case actionTypes.successfulAction:
      return {
        ...state,
        isOpen: true,
        message: payload,
        type: "success",
      };
    case actionTypes.errorHappened:
      return {
        ...state,
        isOpen: true,
        type: "error",
        message: payload.message,
        details: payload.details,
      };
    case actionTypes.warningHappened:
      return {
        ...state,
        isOpen: true,
        type: "warning",
        message: payload.message,
        details: payload.details,
      };
    default: {
      const exhaustiveCheck = state;
      return exhaustiveCheck;
    }
  }
}

export function ToastProvider({ children }) {
  const [{ isOpen, type, message, isExpanded, details }, dispatch] =
    React.useReducer(toastReducer, initialState);

  function handleClose() {
    dispatch({ type: actionTypes.toastClosed });
  }

  function toggleDetails() {
    dispatch({ type: actionTypes.toggleToastDetails });
  }

  return (
    <ToastDispatchContext.Provider value={dispatch}>
      {children}
      <DetailsToast
        isOpen={isOpen}
        type={type}
        message={message}
        onClose={handleClose}
        isExpanded={isExpanded}
        details={details}
        toggleDetails={toggleDetails}
      />
    </ToastDispatchContext.Provider>
  );
}

export function useToastDispatch() {
  const context = React.useContext(ToastDispatchContext);

  if (context === undefined) {
    throw new Error("useToastDispatch must be used within a ToastProvider");
  }

  return context;
}

export function showSuccessToast(dispatch, message) {
  dispatch({ type: actionTypes.successfulAction, payload: message });
}

export function showErrorToast(dispatch, message, details = "") {
  dispatch({ type: actionTypes.errorHappened, payload: { message, details } });
}

export function showWarningToast(dispatch, message, details = "") {
  dispatch({
    type: actionTypes.warningHappened,
    payload: { message, details },
  });
}
